// extracted by mini-css-extract-plugin
module.exports = {"container":"Pagination__container","pages":"Pagination__pages","text":"Pagination__text","previousButton":"Pagination__previousButton","nextButton":"Pagination__nextButton"};